/**
 * BlogHero.tsx — Gold Garage Door / Blog Hub · Section 1/4
 * Navy · compact hero · "Tips, Guides & Garage Door News"
 * MOBILE: real <style> media queries.
 * 10WEB AI: wave dividers intentional — do NOT strip.
 */

const NAVY = "#081438";
const GOLD = "#F5A623";
export default function BlogHero() {
  return <section id="blog-hero" style={{
    background: `radial-gradient(ellipse at 50% 0%, #1a2f5e 0%, ${NAVY} 60%)`,
    position: "relative",
    overflow: "hidden",
    paddingTop: "6rem",
    paddingBottom: "3.5rem"
  }}>
      <style>{`@media (max-width: 560px) { #blog-hero { padding-top: 4.5rem; padding-bottom: 2.5rem; } }`}</style>

      <svg aria-hidden style={{
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      opacity: 0.05,
      pointerEvents: "none"
    }}>
        <filter id="grain-blh"><feTurbulence type="fractalNoise" baseFrequency="0.65" numOctaves="3" stitchTiles="stitch" /><feColorMatrix type="saturate" values="0" /></filter>
        <rect width="100%" height="100%" filter="url(#grain-blh)" />
      </svg>

      <div aria-hidden style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: "1px",
      background: `linear-gradient(90deg, transparent, ${GOLD} 50%, transparent)`
    }} />

      <div style={{
      maxWidth: "800px",
      margin: "0 auto",
      padding: "0 1.5rem",
      textAlign: "center",
      position: "relative",
      zIndex: 1
    }}>
        <div style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "0.5rem",
        background: `${GOLD}18`,
        border: `1px solid ${GOLD}40`,
        borderRadius: "9999px",
        padding: "0.375rem 1rem",
        marginBottom: "1.25rem"
      }}>
          <span style={{
          width: "6px",
          height: "6px",
          borderRadius: "50%",
          background: GOLD,
          display: "inline-block"
        }} />
          <span style={{
          color: GOLD,
          fontSize: "0.7rem",
          fontWeight: 700,
          letterSpacing: "0.12em",
          fontFamily: "'Manrope', sans-serif"
        }}>FROM SYDNEY'S GARAGE DOOR EXPERTS</span>
        </div>

        <h1 style={{
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        fontWeight: 800,
        fontSize: "clamp(1.9rem, 7vw, 3rem)",
        lineHeight: 1.1,
        color: "#FFFFFF",
        marginBottom: "0.75rem"
      }}>
          Tips, Guides & <span style={{
          color: GOLD
        }}>Garage Door News</span>
        </h1>

        <p style={{
        fontFamily: "'Manrope', sans-serif",
        fontSize: "1.05rem",
        color: "rgba(255,255,255,0.7)",
        lineHeight: 1.7,
        maxWidth: "560px",
        margin: "0 auto"
      }}>
          Practical advice from the team that's been fixing Sydney's garage doors since 2009.
        </p>
      </div>

      <div aria-hidden style={{
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      lineHeight: 0
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}>
          <path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill="#FAF7F1" />
        </svg>
      </div>
    </section>;
}